<div class="admin-container">
  <div class="admin-header">
    <!-- <h1>🛠️ Tool Management Admin</h1> -->
    <h4>Add, edit, or remove tools from your Exploration Tool Hub</h4>
  </div>

  <!-- Success/Error Messages -->
  <div *ngIf="successMessage" class="alert alert-success">
    {{ successMessage }}
  </div>
  <div *ngIf="errorMessage" class="alert alert-error">
    {{ errorMessage }}
  </div>

  <!-- Add Tool Button -->
  <div class="admin-content">
    <div class="action-bar">
      <button
        class="btn-primary"
        (click)="toggleForm()"
        [disabled]="showForm"
      >
        {{ showForm ? '✓ Form Open' : '+ Add New Tool' }}
      </button>
    </div>

    <!-- Add/Edit Form -->
    <div *ngIf="showForm" class="form-section">
      <div class="form-header">
        <h2>{{ editingId ? 'Edit Tool' : 'Add New Tool' }}</h2>
      </div>

      <form [formGroup]="toolForm" (ngSubmit)="editingId ? updateTool() : addTool()" class="tool-form">
        <div class="form-row">
          <div class="form-group">
            <label>Tool Name *</label>
            <input
              type="text"
              formControlName="name"
              placeholder="e.g., Well Header Cleaning Tool"
              class="form-input"
            >
            <span class="error" *ngIf="toolForm.get('name')?.invalid && toolForm.get('name')?.touched">
              Name is required (min 3 characters)
            </span>
          </div>

          <div class="form-group">
            <label>Category *</label>
            <select formControlName="category" class="form-input">
              <option value="">Select a category</option>
              <option *ngFor="let cat of categories" [value]="cat">{{ cat }}</option>
            </select>
            <span class="error" *ngIf="toolForm.get('category')?.invalid && toolForm.get('category')?.touched">
              Category is required
            </span>
          </div>
        </div>

        <div class="form-group">
          <label>Description *</label>
          <textarea
            formControlName="description"
            placeholder="Describe what this tool does..."
            rows="3"
            class="form-input"
          ></textarea>
          <span class="error" *ngIf="toolForm.get('description')?.invalid && toolForm.get('description')?.touched">
            Description is required (min 10 characters)
          </span>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label>Icon *</label>
            <div class="icon-select">
              <img
                *ngIf="toolForm.get('icon')?.value"
                [src]="toolForm.get('icon')?.value"
                alt="Selected icon preview"
                class="icon-preview"
              >
              <select formControlName="icon" class="form-input">
                <option value="">Select an icon</option>
                <option *ngFor="let ic of icons" [value]="ic.value">{{ ic.label }}</option>
              </select>
            </div>
            <span class="error" *ngIf="toolForm.get('icon')?.invalid && toolForm.get('icon')?.touched">
              Icon is required
            </span>
          </div>

          <div class="form-group">
            <label>Tool URL *</label>
            <input
              type="url"
              formControlName="url"
              placeholder="https://your-tool-url.com"
              class="form-input"
            >
            <span class="error" *ngIf="toolForm.get('url')?.invalid && toolForm.get('url')?.touched">
              Valid URL is required (https://...)
            </span>
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-submit" [disabled]="toolForm.invalid">
            {{ editingId ? '✓ Update Tool' : '+ Add Tool' }}
          </button>
          <button type="button" class="btn-cancel" (click)="cancelEdit()">
            Cancel
          </button>
        </div>
      </form>
    </div>

    <!-- Tools List -->
    <div class="tools-list">
      <div class="list-header">
        <h2>Existing Tools ({{ tools.length }})</h2>
      </div>

      <div *ngIf="tools.length > 0; else noTools" class="tools-table">
        <div class="table-header">
          <div class="col-id">ID</div>
          <div class="col-name">Name</div>
          <div class="col-category">Category</div>
          <div class="col-description">Description</div>
          <div class="col-actions">Actions</div>
        </div>

        <div *ngFor="let tool of tools; let i = index" class="table-row">
          <div class="col-id">{{ i + 1 }}</div>
          <div class="col-name">{{ tool.name }}</div>
          <div class="col-category">
            <span class="badge">{{ tool.category }}</span>
          </div>
          <div class="col-description">{{ tool.description }}</div>
          <div class="col-actions">
            <button class="btn-edit" (click)="editTool(tool)" title="Edit">
              ✎ Edit
            </button>
            <button class="btn-delete" (click)="deleteTool(tool.id)" title="Delete">
              🗑️ Delete
            </button>
          </div>
        </div>
      </div>

      <ng-template #noTools>
        <div class="no-tools">
          <p>📭 No tools added yet. Click "Add New Tool" to get started!</p>
        </div>
      </ng-template>
    </div>
  </div>
</div>
